// extracted by mini-css-extract-plugin
export default {"fullname_div":"Register_fullname_div__jWDYg","message_div":"Register_message_div__OMKP0"};